/** A bounded key value cache: the least recently read entry is dropped once the cap is reached. */
export class LruCache<V> {
  private readonly entries = new Map<string, V>();

  constructor(private readonly cap: number) {}

  get(key: string): V | undefined {
    const value = this.entries.get(key);
    if (value === undefined) return undefined;
    this.entries.delete(key);
    this.entries.set(key, value);
    return value;
  }

  clear(): void {
    this.entries.clear();
  }

  set(key: string, value: V): void {
    this.entries.delete(key);
    this.entries.set(key, value);
    if (this.entries.size > this.cap) {
      const oldest = this.entries.keys().next().value;
      if (oldest !== undefined) this.entries.delete(oldest);
    }
  }
}
